export default function CashRegister() {
  return (
    <section className="sales-layout__page">
      <h1>Kasse</h1>
      <p>Die Kassenfunktionen sind in Vorbereitung.</p>
    </section>
  );
}
